import SocketCommand from '@/api/SocketCommand.js'
import {clone} from '@/lib/helper/helper.js'
import {isObject} from '@/lib/data/Validations/utils/Utils.js'

export const handleTableUpdate = (command, data) => {
  if (!data?.TableId || !data?.Action) return

  getTable(data.TableId, data.Action)
}

export const getTable = (id, action = 'update') => {
  if (!id) return
  const tableIdArray = Array.isArray(id) ? id : [id]
  window.callAS(SocketCommand.Table.Get, {TableId: tableIdArray, Action: action})
}

export const updateTable = (itemsArray) => {
  if (!Array.isArray(itemsArray) && !isObject(itemsArray)) return

  if (isObject(itemsArray)) itemsArray = [itemsArray]

  const vm = window?.Vue
  const areas = clone(vm.$DataStore.tables || [])

  itemsArray.forEach((item) => {
    const areaIdx = areas.findIndex(area => area.Id === item.AreaId)
    if (areaIdx > -1) {
      const tableIdx = areas[areaIdx].Tables?.findIndex(order => order.Id === item.Id)
      areas[areaIdx].Tables[tableIdx] = item
    }
  })

  updateTableList(areas)
}

const updateTableList = (areas) => {
  if (!Array.isArray(areas)) return

  const vm = window?.Vue
  vm.$bus.$emit(SocketCommand.Table.AllByArea, areas)
}
